export const uniq = (array: Array<unknown>): Array<unknown> => {
  return [...new Set(array)];
};

// from https://stackoverflow.com/a/40808569
export const uniqBy = <T>(
  arr: Array<T>,
  predicate: ((item: T) => unknown) | keyof T,
): Array<T> => {
  const cb =
    typeof predicate === 'function'
      ? (predicate as (item: T) => unknown)
      : (o: T) => o[predicate as keyof T];

  return [
    ...arr
      .reduce((map, item) => {
        const key = item === null || item === undefined ? item : cb(item);

        map.has(key) || map.set(key, item);

        return map;
      }, new Map<unknown, T>())
      .values(),
  ];
};

export const areArraysEqual = (
  a: Array<unknown> = [],
  b: Array<unknown> = [],
): boolean =>
  a.length === b.length && a.every((val, index) => val === b[index]);
